import React from "react";
import styled from "styled-components";
import { words } from "../translations";

// Minimal, purely cosmetic checkbox that can work with either API:
// - Legacy props: selected + onClick()
// - New props:    checked + onToggle(nextChecked)
const SkipCheckbox = ({
  selected,
  checked,
  onClick,
  onToggle,
  language = "EN",
  disabled,
  style,
}) => {
  const isChecked = (typeof checked === "boolean" ? checked : undefined);
  const isSelected = (typeof selected === "boolean" ? selected : undefined);
  const active = (isChecked !== undefined ? isChecked : !!isSelected);

  const handleToggle = () => {
    if (typeof onToggle === "function") {
      onToggle(!active);
    } else if (typeof onClick === "function") {
      onClick();
    }
  };

  const label = (words["do_not_wish_to_answer"] && words["do_not_wish_to_answer"][language])
    ? words["do_not_wish_to_answer"][language]
    : (words["Skip"] ? words["Skip"][language] : "Skip");

  return (
    <Wrapper style={style}>
      <Label disabled={disabled} onClick={handleToggle}>
        <Box role="checkbox" aria-checked={active} data-active={active} onClick={handleToggle} />
        <Text>{label}</Text>
      </Label>
    </Wrapper>
  );
};

export default SkipCheckbox;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-top: 16px;
`;

const Label = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

const Box = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #bcc3cc;
  background-color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  transition: all 0.2s ease;
  cursor: pointer;

  &[data-active='true'] {
    border-color: #2D70E2;
    background-color: #D5E2F9;
  }
`;

const Text = styled.span`
  font-size: 14px;
  color: #2A3039;
  font-family: "Raleway", sans-serif;
`;


